module.exports = __webpack_public_path__ + "0aff28faa2b3abc8e49af155b7c41972.svg";